import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { CheckCircle, Circle, ArrowRight } from "@phosphor-icons/react";
import { useApi } from "@/lib/api";

export const SetupChecklist = () => {
  const api = useApi();
  const { data } = useQuery({ queryKey: ["setup-checklist"], queryFn: () => api.get("/setup/checklist"), refetchOnWindowFocus: "always" });
  if (!data || data.complete) return null;
  const pct = Math.round((data.done / data.total) * 100);
  return (
    <section data-testid="setup-checklist" className="mt-8 rounded-xl border border-[#2A2A2A] bg-[#121212] p-6">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <h3 className="font-display text-lg">Calibrate your setup</h3>
          <p className="text-sm text-[#A3A3A3]">Each step makes your runway more precise. This list hides once you're done.</p>
        </div>
        <p data-testid="setup-progress" className="font-mono text-sm"><span className="text-[#00FF9D] text-xl">{data.done}</span>/{data.total} done</p>
      </div>
      <div className="mt-4 h-1.5 rounded-full bg-[#1E1E1E] overflow-hidden">
        <div className="h-full bg-[#00FF9D] transition-[width] duration-700" style={{ width: `${pct}%` }} />
      </div>
      <ul className="mt-5 grid sm:grid-cols-2 lg:grid-cols-3 gap-2">
        {data.items.map((i) => (
          <li key={i.key} data-testid={`setup-item-${i.key}`} data-done={i.done ? "true" : "false"}
            className={`flex items-start gap-3 rounded-lg border px-3 py-3 ${i.done ? "border-[#00FF9D]/30 bg-[#00FF9D]/[0.04]" : "border-[#2A2A2A]"}`}>
            {i.done ? <CheckCircle weight="fill" className="text-[#00FF9D] mt-0.5 shrink-0" size={18} /> : <Circle className="text-[#4A4A4A] mt-0.5 shrink-0" size={18} />}
            <span className="flex-1 min-w-0">
              <span className={`block text-sm ${i.done ? "text-[#A3A3A3] line-through" : ""}`}>{i.label}</span>
              <span className="block text-[11px] text-[#6B6B6B]">{i.hint}</span>
            </span>
            {!i.done && i.to !== "/app/integrations" && (
              <Link to={i.to} data-testid={`setup-go-${i.key}`} className="text-[#00FF9D] hover:translate-x-0.5 transition-transform"><ArrowRight size={16} /></Link>
            )}
          </li>
        ))}
      </ul>
    </section>
  );
};
